import React from 'react';
import { Star, FileCheck, Clock, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const TrustBar = () => {
  const trustItems = [
    {
      icon: Star,
      text: `${companyInfo.rating}/5 — ${companyInfo.reviewCount} avis`,
      highlight: true
    },
    {
      icon: FileCheck,
      text: 'Devis clair avant intervention'
    },
    {
      icon: Clock,
      text: 'Intervention rapide (30–60 min selon secteur)'
    },
    {
      icon: MapPin,
      text: `${companyInfo.zone} (${companyInfo.serviceRadius})`
    }
  ];

  return (
    <div className="bg-white py-8 border-y border-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div 
                key={index}
                className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-[#2F80ED]/5 transition-colors duration-300"
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
                  item.highlight 
                    ? 'bg-yellow-100' 
                    : 'bg-[#2F80ED]/10'
                }`}>
                  <IconComponent className={`w-5 h-5 ${
                    item.highlight 
                      ? 'text-yellow-600' 
                      : 'text-[#2F80ED]'
                  }`} />
                </div>
                <p className="text-sm font-medium text-[#0B2A4A]">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;
